import { type SwitchTokens } from './types';

export const switchTokens: SwitchTokens = {
  sizes: {
    container: {
      medium: {
        width: '42px',
        height: '26px',
      },
    },
    slider: {
      medium: {
        width: '40px',
        height: '1',
        bubbleSize: '1',
      },
    },
  },
  colors: {
    bg: 'neutral.50',
    borderColor: 'neutral.50',
    checkedBg: 'primary.50',
    checkedBorderColor: 'primary.50',
    activeBg: 'primary.50',
    checkedVersionBBG: 'neutral.30',
    ghost: {
      bg: 'neutral.0',
      checkedVersionBBG: 'neutral.20',
      checkedBorderColor: 'primary.30',
      borderColor: 'neutral.50',
      offColor: 'neutral.50',
    },
  },
  space: {
    left: '0',
    checkedLeft: '-2x_small',
  },
};
